// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "5bf178ac8e02ad1b58d9" + ".js";
};